import { render, staticRenderFns } from "./russian-cyrillic.vue?vue&type=template&id=6e5e863b&scoped=true&"
import script from "./russian-cyrillic.vue?vue&type=script&lang=js&"
export * from "./russian-cyrillic.vue?vue&type=script&lang=js&"
import style0 from "./russian-cyrillic.vue?vue&type=style&index=0&id=6e5e863b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e863b",
  null
  
)

export default component.exports